import CLIENT from '../utils/restClient';
import Logger, {LOG_LEVELS} from '../utils/logger';

export const MODULE_NAME = 'VATCODE_SIMULATOR_CONTROLLER';
const log = new Logger(MODULE_NAME, LOG_LEVELS.DEBUG);
function namespaced(name) {
    return MODULE_NAME+'.'+name;
}
const LOAD = namespaced('LOAD');
const LOAD_OK = namespaced('LOAD_OK');
const LOAD_FAIL = namespaced('LOAD_FAIL');
const LOAD_COMPANY_VATCODES = namespaced('LOAD_COMPANY_VATCODES');
const LOAD_COMPANY_VATCODES_OK = namespaced('LOAD_COMPANY_VATCODES_OK');
const LOAD_COMPANY_VATCODES_FAIL = namespaced('LOAD_COMPANY_VATCODES_FAIL');
const UNLOAD_SIMULATION = namespaced('UNLOAD_SIMULATION');

// For now we are overloading the use of UPDATE to include delete too.
export const ACTION_TYPES = {
    LOAD,
    LOAD_OK,
    LOAD_FAIL,
    LOAD_COMPANY_VATCODES,
    LOAD_COMPANY_VATCODES_OK,
    LOAD_COMPANY_VATCODES_FAIL,
    UNLOAD_SIMULATION
};

// In redux parlance, this is a reducer
export const updateSubStateFromAction = (state = {data: undefined, loading: false, error: null, uploading: false}, action) => {
    log.debug('actionHandler: ', action, state );
    const getNewState = (action, state) => {
        switch (action.type) {
            case LOAD:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_OK:
                return Object.assign({}, state, {vatCodeDetails: action.response, loading: false, error: null});
            case LOAD_FAIL:
                return Object.assign({}, state, {vatCodeDetails: undefined, loading: false, error: action.error});
            case LOAD_COMPANY_VATCODES:
                return  Object.assign({}, state, {loading: true, error: null});
            case LOAD_COMPANY_VATCODES_OK:
                return Object.assign({}, state, {companyVatCodes: action.response, loading: false, error: null});
            case LOAD_COMPANY_VATCODES_FAIL:
                return Object.assign({}, state, {data: undefined, loading: false, error: action.error});
          case UNLOAD_SIMULATION:
              return Object.assign({}, state, {vatCodeDetails: undefined});
            default:
                return state;
        }
    };
    const newState = getNewState(action, state);
    log.debug('actionHandler:  newState', newState );
    return newState;
};

export const API = {
    doVATCodeSimulation: (params) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD});
            return CLIENT.getVATCodeSimulation(params)
                .then((response) => {
                    log.debug('doVATCodeSimulation success: ', response );
                    dispatch({type: LOAD_OK, response: response});
                })
                .catch((error) => {
                    log.debug('doVATCodeSimulation error' );
                    dispatch({type: LOAD_FAIL, error});
                });
        }
    },
    doLoad: (params) => {
        return (dispatch, getState) => {
            dispatch({type: LOAD_COMPANY_VATCODES});
            return CLIENT.getCompanyVATCodes(params)
                .then((response) => {
                    dispatch({type: LOAD_COMPANY_VATCODES_OK, response: response});
                })
                .catch((error) => {
                    dispatch({type: LOAD_COMPANY_VATCODES_FAIL, error});
                });
        }
    },
    doUnload: () => {
      return (dispatch, getState) => {
        dispatch({type: UNLOAD_SIMULATION});
      }
    }
};

export default API;

